// tslint:disable

import { get } from 'lodash';
import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
import { IriField } from '../../components/fields/iri.field';
import { Field, FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';

export class DefaultCompanyAdmin extends React.Component<any, any> {
    public state: any = {
        company: null,
        selectedCompany: null,
        selectedCompanySiteSpec: null
    };
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);
    private companySelector: Field = new Field({
        'title': 'Select company',
        'iri': 'company',
        'property': 'companySelector',
        'multi': false
    });

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    componentDidMount() {
        this.companySelector.onValueChanges$.subscribe((value: string) => {
            this.setState({selectedCompany: value});
        });
    }

    handleCompanySiteSpecChange(value: any) {
        value = value.replace('/company-site-spec/', '');
        this.setState({selectedCompanySiteSpec: value});
    }

    render() {
        return (
            <ResourceLoader entity="company-admin" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div id="page-title">
                    <h2>
                        {this.props.IS_CREATE ? 'Create new company admin' : 'Edit company admin'}
                    </h2>
                    <p>Lorem</p>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <ToggleBoxComponent title="Admin details" color="green" alwaysOpen={true}>
                    <div className="row">
                        <div className="col-xs-12">
                            {!this.props.CONFIG || this.props.CONFIG.companySiteSpec &&
                            <IriField
                                field={this.companySelector}
                                //forceQuery={{company: this.state.selectedCompanySiteSpec, pagination: false}}
                                disabled={this.state.selectedCompanySiteSpec > -1}
                                defaultAll={false}
                                //defaultValue={this.props.CONFIG ? `/company/${this.props.CONFIG.company}` : ''}
                                itemRender={(item: any) => item.name}
                            />
                            }

                            <IriField
                                field={form.fields.companySiteSpec}
                                onChange={(value: any) => this.handleCompanySiteSpecChange(value)}
                                defaultValue={this.props.CONFIG ? `/company-site-spec/${this.props.CONFIG.companySiteSpec}` : ''}
                                defaultAll={false}
                                disabled={(this.props.CONFIG && this.props.CONFIG.companySiteSpec) ? true : false}
                                itemRender={(CompanySiteSpec: any) =>
                                    <IriPresenter iri={get(CompanySiteSpec, 'company.@id')} render={(person: any) =>
                                        get(person, 'name')


                                    }/>
                                }
                            />
                            {((this.props.CONFIG && this.props.CONFIG.companySiteSpec) || (this.state.selectedCompanySiteSpec)) &&
                            <IriField
                                field={form.fields.personCompany}
                                forceQuery={{company: this.props.CONFIG.company, pagination: false}}
                                defaultValue={this.props.CONFIG ? `/person-company/${this.props.CONFIG.personCompany}` : ''}
                                disabled={(this.props.CONFIG && this.props.CONFIG.companySiteSpec) ? true : false}
                                defaultAll={false}
                                itemRender={(personCompany: any) =>
                                    <IriPresenter iri={get(personCompany, 'person.@id')} render={(person: any) =>
                                        get(person, 'firstName') + ' ' + get(person, 'surName')
                                    }/>
                                }
                            />
                            }

                            <CheckboxField field={form.fields.active}/>

                            <blockquote>
                                {/* #TODO */}
                                Ide jon egy ROLE selector [ROLE_ADMIN, ROLE_SUPER_ADMIN]
                            </blockquote>
                            <blockquote>
                                Meg kell oldani, hogy a Companynak megfeleloen szurt PersonComnpanykat kapjunk!
                                <br/>
                                Amikor betoltodik az oldal akkor is; es amikor valaszt a user a Companykbol.
                            </blockquote>

                        </div>


                        <div className="col-xs-12">
                            <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save</button>
                        </div>
                    </div>
                </ToggleBoxComponent>
            </div>}/>
        );
    }

}



// WEBPACK FOOTER //
// ./src/__templates/details/default.company-admin.tsx